import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common'; // Often needed for directives
import { SpinDirective } from '../directives/spin.directive';

@NgModule({
  imports: [
    CommonModule,
    SpinDirective
  ],
  declarations: [

  ],
  exports: [
    SpinDirective
  ]
})
export class CoreModule {

}
